<template>
    <div>
        <card-header title="Edit Registration Type/Fee" icon="fa-pencil"/>

        <card-body>
            <conf-type-form :type="type" :conference-id="props.confId"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteType"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Type?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!type.title || !type.fee"
                    ><i class="fas fa-check mr-2"></i>Save Type/Fee
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import ConfTypeForm from "./TypeForm";
    import moment from "moment/moment";

    export default {
        components: {ConfTypeForm, RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                type: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadType: function() {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/types/' + this.props.typeId, {force: true}).then(response => {
                    this.type = response.data;
                    this.type.fee = this.type.fee.toString();
                    this.type.enabled_at = (response.data.enabled_at) ? moment(response.data.enabled_at).toDate() : null;
                    this.type.disabled_at = (response.data.disabled_at) ? moment(response.data.disabled_at).toDate() : null;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('conferences/' + this.props.confId + '/types/' + this.props.typeId, {
                    id: this.type.id,
                    title: this.type.title,
                    fee: this.type.fee,
                    is_enabled: this.type.is_enabled,
                    cc_surcharge: this.type.cc_surcharge,
                    cc_surcharge_info: this.type.cc_surcharge_info,
                    cc_fee: this.type.cc_fee,
                    po_fee: this.type.po_fee,
                    org_share: this.type.org_share,
                    self_share: this.type.self_share,
                    hour_limit: this.type.hour_limit,
                    enabled_at: this.type.enabled_at,
                    disabled_at: this.type.disabled_at,
                    tax_rate: this.type.tax_rate,
                    tax_state_rate: this.type.tax_state_rate,
                    tax_local_rate: this.type.tax_local_rate,
                    tax_jurisdiction: this.type.tax_jurisdiction,
                    tax_location_code: this.type.tax_location_code
                }, {force: true}).then(response => {
                    this.$reloadCard('conference', {confId: this.props.confId});
                    this.$reloadCard('conf-reg-types', {confId: this.props.confId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the fee.');
                    this.$emit('loading', false);
                });
            },
            deleteType() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('conferences/' + this.props.confId + '/types/' + this.type.id).then(response => {
                        this.$reloadCard('conf-reg-types', {confId: this.props.confId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.typeId': function() {
                this.dirty = null;
                this.loadType();
            },
            'type': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this type/fee? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadType();
            console.log(this.props)
        }
    };
</script>
